import React from 'react';
import PropTypes from 'prop-types';
import CheckmarkIcon from '../../../common/icons/checkmark/CheckmarkIcon';
import { ONBOARDING_PROGRESS_STEPS } from '../../../../constants/Copy';
import './OnboardingProgress.scss';

const OnboardingProgress = ({ activeStep }) => {
	const isCompleted = (stepId) => stepId < activeStep;

	const getStepClass = (stepId, partially) => {
		if (activeStep === stepId) {
			return partially ? 'completed' : 'active';
		} else if (isCompleted(stepId)) {
			return 'completed';
		} else {
			return '';
		}
	};

	const renderBulb = (stepId) => (
		<div className={`onboarding-progress__step ${getStepClass(stepId)}`}>
			<div className="onboarding-progress__step__icon">
				{isCompleted(stepId) && <CheckmarkIcon small modifierClass="complete-icon" />}
			</div>
			<div className="onboarding-progress__step__name">
				{stepId === 1 && ONBOARDING_PROGRESS_STEPS.CHOOSE}
				{stepId === 2 && ONBOARDING_PROGRESS_STEPS.REGISTER}
				{stepId === 3 && ONBOARDING_PROGRESS_STEPS.VERIFY}
			</div>
		</div>
	);

	return (
		<div className="onboarding-progress" data-test="onboarding-progress">
			{renderBulb(1)}
			{renderBulb(2)}
			{renderBulb(3)}
		</div>
	);
};

OnboardingProgress.propTypes = {
	activeStep: PropTypes.number,
};

export default OnboardingProgress;
